/**
 * @prettier
 */
import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_house_rules';

const houseRulesQuery = `
    query houseRules($unitUrl: String!) {
        houseRules(unitUrl: $unitUrl) {
            checkInTime
            checkOutTime
            children {
                ...houseRule
            }
            smoking {
                ...houseRule
            }
            events {
                ...houseRule
            }
            unitUrl
            pets {
                ...houseRule
            }
            minimumAge {
                label
                note
                minimumAge
            }
            maxOccupancy {
                adults
                guests
                label
                maxAdultsLabel
                note
            }
            standardRules {
                key
                label
                note
            }
            customRules {
                note
            }
        }
    }

    fragment houseRule on HouseRule {
        label
        note
        allowed
    }
`;

async function houseRulesGraphQl({unitUrl, locale}) {
    return await graphqlQuery(OPERATION_NAME, houseRulesQuery, {unitUrl}, locale);
}

export default houseRulesGraphQl;
export {houseRulesGraphQl, OPERATION_NAME, houseRulesQuery};
